import { useFeatureFlags } from 'feature-flags';

export const useRedactPII = () => {
  const { redact_pii } = useFeatureFlags(['redact_pii']);

  return {
    isRedactPII: !!redact_pii,
  };
};
